import InputTexto from '@/components/editorLandingPage/core/menuConfig/InputTexto.vue';
import EditorDeTexto from '@/components/editorLandingPage/core/menuConfig/EditorDeTexto.vue';
import SeletorCor from '@/components/editorLandingPage/core/menuConfig/SeletorCor.vue';
import SeletorArquivo from '@/components/editorLandingPage/core/menuConfig/SeletorArquivo.vue';
import SeletorDimensao from '@/components/editorLandingPage/core/menuConfig/SeletorDimensao.vue';
import SeletorDropdown from '@/components/editorLandingPage/core/menuConfig/SeletorDropdown.vue';
import InputCheckbox from '@/components/editorLandingPage/core/menuConfig/InputCheckbox.vue';
import InputNumero from '@/components/editorLandingPage/core/menuConfig/InputNumero.vue';
import SeletorAcaoBotao from '@/components/editorLandingPage/core/menuConfig/SeletorAcaoBotao.vue';
import ControleDeslizante from '@/components/editorLandingPage/core/menuConfig/ControleDeslizante.vue';
import SeletorMultiplasImagens from '@/components/editorLandingPage/core/menuConfig/SeletorMultiplasImagens.vue';
import ModalListaOrganizavel from '@/components/editorLandingPage/core/menuConfig/ModalListaOrganizavel.vue';
import { v4 } from 'uuid';

import { useStore } from 'vuex';

export const useConfigComponenteEditor = () => {
    const store = useStore();
    const NOME_MODULO_VUEX = 'landingPage';

    const lidarMudancaBotaoLimpar = (valor, componenteId, prop) => {
        const formulario = store.getters[`${NOME_MODULO_VUEX}/formularioAtivo`];
        if (!formulario) return;

        const propMap = {
            alinhamento: 'botaoLimparAlinhamento',
            cor: 'botaoLimparCor',
        };
        const designProp = propMap[prop];
        if (!designProp) return;

        store.dispatch(`${NOME_MODULO_VUEX}/atualizarDesignFormulario`, {
            formularioId: formulario.componenteId,
            design: {
                [designProp]: valor,
            },
        });
    };

    class ColorPicker {
        constructor({ useStyle, label, prop } = { useStyle: true, label: 'Cor de Fundo', prop: 'backgroundColor' }) {
            this.componente = SeletorCor;
            this.componenteProps = {
                label,
            };
            this.prop = prop;
            this.lidarComMudanca = (valor, componenteId) => {
                const corCompleta = valor.startsWith('#') ? valor : `#${valor}`;

                if (!useStyle) {
                    return lidarMudancaPropriedade(corCompleta, componenteId, prop);
                }
                return lidarMudancaEstilo(corCompleta, componenteId, prop);
            };
            this.obterValorAtual = (elemento) => {
                const cor = useStyle ? elemento?.props?.style?.[this.prop] : elemento?.props?.[this.prop];

                return cor || '#f7f7f7';
            };
        }
    }

    class BackgroundColor {
        constructor({ useStyle } = { useStyle: true }) {
            this.componente = SeletorCor;
            this.componenteProps = {
                label: 'Cor de Fundo',
            };
            this.lidarComMudanca = (valor, componenteId) => {
                const corCompleta = valor.startsWith('#') ? valor : `#${valor}`;
                if (!useStyle) {
                    return lidarMudancaPropriedade(corCompleta, componenteId, 'backgroundColor');
                }
                return lidarMudancaEstilo(corCompleta, componenteId, 'backgroundColor');
            };
            this.obterValorAtual = (elemento) => {
                const cor = useStyle ? elemento?.props?.style?.backgroundColor : elemento?.props?.backgroundColor;

                return cor || '#f7f7f7';
            };
        }
    }
    class BackgroundImage {
        constructor() {
            this.componente = SeletorArquivo;
            this.componenteProps = {
                label: 'Imagem de Fundo',
            };
            this.lidarComMudanca = (arquivo, componenteId) => lidarMudancaImagemFundo(arquivo, componenteId);
            this.obterValorAtual = (elemento) => {
                const bgImage = elemento?.props?.style?.backgroundImage;
                if (bgImage && bgImage.startsWith('url(')) {
                    return bgImage.slice(4, -1).replace(/['"]/g, '');
                }
                return null;
            };
        }
    }

    class ImageSrc {
        constructor({ label, prop } = { label: 'Selecione um Arquivo', prop: 'src' }) {
            this.componente = SeletorArquivo;
            this.componenteProps = {
                label,
            };
            this.prop = prop;
            this.lidarComMudanca = (arquivo, componenteId) => lidarComMudancaArquivoImagem(arquivo, componenteId, prop);
            this.obterValorAtual = (elemento) => {
                return elemento?.props?.[this.prop] || null;
            };
        }
    }

    class TextInput {
        constructor({ label, prop } = { label: 'Texto', prop: 'texto' }) {
            this.componente = InputTexto;
            this.componenteProps = {
                label,
            };
            this.lidarComMudanca = (valor, componenteId) => lidarMudancaPropriedade(valor, componenteId, prop);
            this.prop = prop;
            this.obterValorAtual = (elemento) => {
                return elemento?.props?.[prop] || '';
            };
        }
    }

    class EditorDeTextoInput {
        constructor({ label, prop } = { label: 'Texto', prop: 'texto' }) {
            this.componente = EditorDeTexto;
            this.componenteProps = {
                label,
            };
            this.lidarComMudanca = (valor, componenteId) => lidarMudancaPropriedade(valor, componenteId, prop);
            this.prop = prop;
            this.obterValorAtual = (elemento) => {
                return elemento?.props?.[prop] || '';
            };
        }
    }

    class DimensionInput {
        constructor(label, prop, unidade = 'px', funcaoManipuladora = lidarMudancaPropriedade) {
            this.componente = SeletorDimensao;
            this.componenteProps = {
                label,
                unidade,
            };
            this.prop = prop;
            this.lidarComMudanca = (valor, componenteId) => funcaoManipuladora(valor, componenteId, prop);
            this.obterValorAtual = (elemento) => {
                const valor = funcaoManipuladora === lidarMudancaEstilo ? elemento?.props?.style?.[this.prop] : elemento?.props?.[this.prop];
                return valor || '100%';
            };
        }
    }

    class StyleSliderInput {
        constructor({ label = 'Controle Deslizante', prop = 'valor', unidade = 'px', useStyle = false, min, max } = {}) {
            this.componente = ControleDeslizante;
            this.componenteProps = { label, min, max };
            this.prop = prop;
            this.unidade = unidade;
            this.useStyle = useStyle;

            this.lidarComMudanca = (valor, componenteId) => {
                const valorFinal = this.unidade === '' ? Number(valor) : `${valor}${this.unidade}`;

                if (!useStyle) {
                    return lidarMudancaPropriedade(valorFinal, componenteId, this.prop);
                }
                return lidarMudancaEstilo(valorFinal, componenteId, this.prop);
            };

            this.obterValorAtual = (elemento) => {
                const valor = useStyle ? elemento?.props?.style?.[this.prop] : elemento?.props?.[this.prop];
                if (this.unidade === '') {
                    return valor ? Number(valor) : 0;
                }
                return valor ? parseInt(String(valor).replace(this.unidade, '')) : 0;
            };
        }
    }

    class DropdownSelector {
        constructor(label, prop, options, funcaoManipuladora = lidarMudancaPropriedade, funcaoBuscadora = null) {
            this.componente = SeletorDropdown;
            this.componenteProps = { label, options };
            this.prop = prop;
            this.options = options;
            this.funcaoManipuladora = funcaoManipuladora;
            this.funcaoBuscadora = funcaoBuscadora;

            this.lidarComMudanca = (valor, componenteId) => {
                funcaoManipuladora(valor, componenteId, prop);
            };

            this.obterValorAtual = (elemento) => {
                let valorAtual;

                if (this.funcaoBuscadora) {
                    valorAtual = this.funcaoBuscadora(elemento, this.prop);
                } else {
                    valorAtual = elemento?.props?.[this.prop];
                }

                if (typeof valorAtual === 'boolean') {
                    return String(valorAtual);
                }
                return valorAtual || this.options[0]?.value || '';
            };
        }
    }

    class BooleanDropdownSelector {
        constructor(label, prop, options, funcaoManipuladora = lidarMudancaPropriedade) {
            this.componente = SeletorDropdown;
            this.componenteProps = {
                label,
                options: options.map((opt) => ({ ...opt, value: String(opt.value) })),
            };
            this.prop = prop;
            this.options = options;
            this.lidarComMudanca = (valor, componenteId) => {
                funcaoManipuladora(valor, componenteId, prop);
            };
            this.obterValorAtual = (elemento) => {
                const valorAtual = elemento?.props?.[this.prop];
                if (typeof valorAtual === 'boolean') {
                    return String(valorAtual);
                }
                return 'false';
            };
        }
    }

    class CheckboxInput {
        constructor(label, prop) {
            this.componente = InputCheckbox;
            this.componenteProps = { label };
            this.prop = prop;
            this.lidarComMudanca = (valor, componenteId) => lidarMudancaPropriedade(valor, componenteId, prop);
            this.obterValorAtual = (elemento) => {
                return elemento?.props?.[this.prop] || false;
            };
        }
    }

    class NumberInput {
        constructor({ label, prop, min, max, tooltip, funcaoManipuladora = lidarMudancaPropriedade } = {}) {
            this.componente = InputNumero;
            this.componenteProps = { label, min, max, tooltip };
            this.prop = prop;
            this.min = min;
            this.lidarComMudanca = (valor, componenteId) => funcaoManipuladora(Number(valor), componenteId, prop);
            this.obterValorAtual = (elemento) => {
                return elemento?.props?.[this.prop] || this.min;
            };
        }
    }

    class SliderInput {
        constructor({ label, prop, min, max }) {
            this.componente = ControleDeslizante;
            this.componenteProps = { label, min, max, mostrarInput: false };
            this.prop = prop;
            this.min = min;
            this.lidarComMudanca = (valor, componenteId) => lidarMudancaPropriedade(Number(valor), componenteId, prop);
            this.obterValorAtual = (elemento) => {
                return elemento?.props?.[this.prop] || this.min;
            };
        }
    }

    class EditorOpcoesDropdownModal {
        constructor(label, prop) {
            this.componente = ModalListaOrganizavel;
            this.componenteProps = { label };
            this.prop = prop;
            this.lidarComMudanca = (valor, componenteId) => {
                store.dispatch(`${NOME_MODULO_VUEX}/atualizarPropsComponente`, {
                    idComponente: componenteId,
                    novasProps: {
                        [prop]: valor,
                    },
                });
            };
            this.obterValorAtual = (elemento) => {
                return elemento?.props?.[this.prop] || [];
            };
        }
    }

    const normalizar = (v) => String(v ?? '').trim();
    const semArroba = (v) => normalizar(v).replace(/^@/, '');
    const semQueryHash = (v) => normalizar(v).split(/[?#]/)[0];
    const ultimoSegmento = (v) => semQueryHash(v).split('/').filter(Boolean).pop() || '';
    const linkedinPath = (v) => {
        const s = semQueryHash(v);
        const i = s.indexOf('/in/');
        return i >= 0 ? s.slice(i) : '';
    };

    const EXTRATORES = Object.freeze({
        link: (p) => ({ url: semQueryHash(p.link), novaAba: !!p.abrirNovaAba }),
        email: (p) => ({
            destinatario: normalizar(p.emailDestinatario),
            assunto: normalizar(p.emailAssunto),
            corpo: normalizar(p.emailCorpo),
        }),
        whatsapp: (p) => ({ numero: normalizar(p.telefone), mensagem: normalizar(p.mensagem) }),
        telefone: (p) => ({ numero: normalizar(p.telefone) }),
        scroll: (p) => ({ elemento: normalizar(p.scrollElemento) }),
        instagram: (p) => ({ url: semArroba(ultimoSegmento(p.link)) }),
        linkedin: (p) => ({ url: linkedinPath(p.link) }),
        twitter: (p) => ({ url: semArroba(ultimoSegmento(p.link)) }),
        facebook: (p) => ({ url: ultimoSegmento(p.link) }),
    });

    class ActionSelector {
        constructor() {
            this.componente = SeletorAcaoBotao;
            this.componenteProps = {};
            this.lidarComMudanca = (valor, componenteId) => lidarMudancaAcaoBotao(valor, componenteId);
            this.obterValorAtual = (elemento) => {
                const props = elemento?.props ?? {};
                const acao = props.acao || 'link';
                const extrair = EXTRATORES[acao] || (() => ({}));
                return { acao, campos: extrair(props) };
            };
        }
    }

    const lidarComMudancaArquivoImagem = (arquivo, componenteId, prop = 'src') => {
        if (arquivo === null) {
            store.dispatch(`${NOME_MODULO_VUEX}/atualizarPropsComponente`, {
                idComponente: componenteId,
                novasProps: {
                    [prop]: '',
                },
            });
            return;
        }

        if (!arquivo) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            store.dispatch(`${NOME_MODULO_VUEX}/atualizarPropsComponente`, {
                idComponente: componenteId,
                novasProps: {
                    [prop]: `${e.target.result}`,
                },
            });
        };
        reader.readAsDataURL(arquivo);
    };

    const lidarMudancaPropriedade = (valor, componenteId, prop) => {
        store.dispatch(`${NOME_MODULO_VUEX}/atualizarPropsComponente`, {
            idComponente: componenteId,
            novasProps: {
                [prop]: valor,
            },
        });
    };

    const lidarMudancaEstilo = (valor, componenteId, prop) => {
        store.dispatch(`${NOME_MODULO_VUEX}/atualizarPropsComponente`, {
            idComponente: componenteId,
            novasProps: {
                style: {
                    [prop]: valor,
                },
            },
        });
    };

    const obterValorEstilo = (elemento, prop) => {
        return elemento?.props?.style?.[prop];
    };

    const comBarra = (v) => {
        const s = semQueryHash(v);
        return s && s[0] !== '/' ? `/${s}` : s;
    };

    const URL_BASE = Object.freeze({
        instagram: 'https://www.instagram.com',
        linkedin: 'https://www.linkedin.com',
        twitter: 'https://twitter.com',
        facebook: 'https://www.facebook.com',
    });

    const CONSTRUTORES = Object.freeze({
        link: ({ url, novaAba = false } = {}) => ({ link: semQueryHash(url), abrirNovaAba: !!novaAba }),
        email: ({ destinatario, assunto, corpo } = {}) => ({
            emailDestinatario: normalizar(destinatario),
            emailAssunto: normalizar(assunto),
            emailCorpo: normalizar(corpo),
        }),
        whatsapp: ({ numero, mensagem } = {}) => ({ telefone: normalizar(numero), mensagem: normalizar(mensagem) }),
        telefone: ({ numero } = {}) => ({ telefone: normalizar(numero) }),
        scroll: ({ elemento } = {}) => ({ scrollElemento: normalizar(elemento) }),
        instagram: ({ url } = {}) => ({
            link: semArroba(url) ? `${URL_BASE.instagram}/${semArroba(url)}` : '',
            abrirNovaAba: true,
        }),
        linkedin: ({ url } = {}) => ({
            link: semQueryHash(url) ? `${URL_BASE.linkedin}${comBarra(url)}` : '',
            abrirNovaAba: true,
        }),
        twitter: ({ url } = {}) => ({
            link: semArroba(url) ? `${URL_BASE.twitter}/${semArroba(url)}` : '',
            abrirNovaAba: true,
        }),
        facebook: ({ url } = {}) => ({
            link: semQueryHash(url) ? `${URL_BASE.facebook}${comBarra(url)}` : '',
            abrirNovaAba: true,
        }),
    });

    const lidarMudancaAcaoBotao = (valor = {}, componenteId) => {
        const acao = valor.acao || '';
        const campos = valor.campos || {};
        const build = CONSTRUTORES[acao] || (() => ({}));
        const novasProps = { acao, ...build(campos) };

        store.dispatch(`${NOME_MODULO_VUEX}/atualizarPropsComponente`, {
            idComponente: componenteId,
            novasProps,
        });
    };

    const lidarMudancaImagemFundo = (arquivo, componenteId) => {
        if (arquivo === null) {
            store.dispatch(`${NOME_MODULO_VUEX}/atualizarPropsComponente`, {
                idComponente: componenteId,
                novasProps: {
                    style: {
                        backgroundImage: 'none',
                        backgroundSize: null,
                        backgroundPosition: null,
                        backgroundRepeat: null,
                    },
                },
            });
            return;
        }

        if (!arquivo) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            store.dispatch(`${NOME_MODULO_VUEX}/atualizarPropsComponente`, {
                idComponente: componenteId,
                novasProps: {
                    style: {
                        backgroundImage: `url(${e.target.result})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                    },
                },
            });
        };
        reader.readAsDataURL(arquivo);
    };

    const lidarMudancaComponente = (novoComponente, componenteId) => {
        store.dispatch(`${NOME_MODULO_VUEX}/alterarTipoComponente`, {
            idComponente: componenteId,
            novoTipo: novoComponente,
        });
    };

    const lidarMudancaGrade = (valor, componenteId, prop) => {
        store.dispatch(`${NOME_MODULO_VUEX}/atualizarPropsComponente`, {
            idComponente: componenteId,
            novasProps: {
                [prop]: valor,
            },
        });

        const celulasAtuais = store.getters[`${NOME_MODULO_VUEX}/obterChildrenPorId`](componenteId);

        const buscarPorId = (obj, id) => {
            if (obj.componenteId === id) return obj;
            if (obj.children) {
                for (const child of obj.children) {
                    const found = buscarPorId(child, id);
                    if (found) return found;
                }
            }
            return null;
        };

        const componente = buscarPorId(store.state[NOME_MODULO_VUEX].estruturaPagina, componenteId);
        if (!componente) return;

        const linhas = prop === 'linhas' ? valor : componente.props.linhas || 2;
        const colunas = prop === 'colunas' ? valor : componente.props.colunas || 2;

        console.log(`Redimensionando grade: ${linhas}x${colunas} = ${linhas * colunas} células`);

        const novasCelulas = [];
        for (let i = 0; i < linhas; i++) {
            for (let j = 0; j < colunas; j++) {
                const celulaExistente = celulasAtuais.find((celula) => celula.props?.row === i && celula.props?.col === j);

                if (celulaExistente) {
                    novasCelulas.push(celulaExistente);
                } else {
                    novasCelulas.push({
                        componenteId: v4(),
                        componente: 'celulaGrade',
                        props: {
                            row: i,
                            col: j,
                        },
                        children: [],
                    });
                }
            }
        }

        store.dispatch(`${NOME_MODULO_VUEX}/definirChildrenPorId`, {
            idComponente: componenteId,
            novaListaItens: novasCelulas,
        });
    };

    const seletorTipoDeCampo = {
        componente: SeletorDropdown,
        componenteProps: {
            label: 'Tipo de Campo',
            options: [
                { value: 'campoTexto', label: 'Texto' },
                { value: 'campoNumerico', label: 'Numero' },
                { value: 'campoDropdown', label: 'Select' },
                { value: 'campoCNPJ', label: 'CNPJ' },
                { value: 'campoCep', label: 'CEP' },
                { value: 'campoEmail', label: 'E-mail' },
                { value: 'campoCheckbox', label: 'Checkbox' },
                { value: 'campoData', label: 'Data' },
            ],
        },
        lidarComMudanca: (valor, componenteId) => lidarMudancaComponente(valor, componenteId),
        obterValorAtual: (elemento) => {
            return elemento?.componente;
        },
    };

    const CONFIG_PADRAO_CAMPOS = {
        campos: [
            seletorTipoDeCampo,
            new TextInput({ label: 'Titulo do Campo', prop: 'label' }),
            new NumberInput({
                label: 'Tamanho do Campo (caracteres)',
                prop: 'length',
                min: 0,
                max: 999999,
                tooltip: 'Define a quantidade máxima de caracteres que o usuário pode inserir no campo.',
            }),
            new BooleanDropdownSelector('Obrigatório', 'required', [
                { value: false, label: 'Não' },
                { value: true, label: 'Sim' },
            ]),
        ],
    };

    const CONFIG_NUMERICO_CAMPOS = {
        campos: [
            seletorTipoDeCampo,
            new TextInput({ label: 'Titulo do Campo', prop: 'label' }),
            new NumberInput({
                label: 'Tamanho do Campo (caracteres)',
                prop: 'length',
                min: 0,
                max: 999999,
                tooltip: 'Define a quantidade máxima de digitos que o usuário pode inserir no campo.',
            }),
            new BooleanDropdownSelector('Obrigatório', 'required', [
                { value: false, label: 'Não' },
                { value: true, label: 'Sim' },
            ]),
        ],
    };

    const CONFIG_DATA_CAMPOS = {
        campos: [
            seletorTipoDeCampo,
            new TextInput({ label: 'Titulo do Campo', prop: 'label' }),
            new BooleanDropdownSelector('Obrigatório', 'required', [
                { value: false, label: 'Não' },
                { value: true, label: 'Sim' },
            ]),
        ],
    };

    const CONFIG_SOMENTE_OBRIGATORIO = {
        campos: [
            new BooleanDropdownSelector('Obrigatório', 'required', [
                { value: false, label: 'Não' },
                { value: true, label: 'Sim' },
            ]),
        ],
    };

    const COMPONENT_CONFIGS = {
        rodape: {
            campos: [
                new BackgroundColor(),
                new BackgroundImage(),
                new StyleSliderInput({ label: 'Borda', prop: 'borderRadius' }),
                new DropdownSelector('Sombra', 'boxShadow', [
                    { value: '0 1px rgb(0 0 0 / 0.05)', label: 'Extra Extra Pequena' },
                    { value: '0 1px 2px 0 rgb(0 0 0 / 0.05)', label: 'Extra Pequena' },
                    { value: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)', label: 'Pequena' },
                    { value: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)', label: 'Média' },
                    { value: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)', label: 'Grande' },
                    { value: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)', label: 'Extra Grande' },
                    { value: '0 25px 50px -12px rgb(0 0 0 / 0.25)', label: 'Extra Extra Grande' },
                ]),
                new StyleSliderInput({ label: 'Margem Horizontal', prop: 'marginX', useStyle: false }),
            ],
        },
        cabecalho: {
            campos: [
                new BackgroundColor(),
                new BackgroundImage(),
                new StyleSliderInput({ label: 'Borda', prop: 'borderRadius' }),
                new DropdownSelector('Sombra', 'boxShadow', [
                    { value: '0 1px rgb(0 0 0 / 0.05)', label: 'Extra Extra Pequena' },
                    { value: '0 1px 2px 0 rgb(0 0 0 / 0.05)', label: 'Extra Pequena' },
                    { value: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)', label: 'Pequena' },
                    { value: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)', label: 'Média' },
                    { value: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)', label: 'Grande' },
                    { value: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)', label: 'Extra Grande' },
                    { value: '0 25px 50px -12px rgb(0 0 0 / 0.25)', label: 'Extra Extra Grande' },
                ]),
                new StyleSliderInput({ label: 'Margem Horizontal', prop: 'marginX', useStyle: false }),
            ],
        },
        imagem: {
            campos: [
                new ImageSrc(),
                new TextInput({ label: 'Texto alternativo', prop: 'alt' }),
                new BackgroundColor({ useStyle: false }),
                new DimensionInput('Largura', 'largura'),
                new StyleSliderInput({ label: 'Borda', prop: 'borderRadius' }),
                new DropdownSelector('Sombra', 'boxShadow', [
                    { value: '0 1px rgb(0 0 0 / 0.05)', label: 'Extra Extra Pequena' },
                    { value: '0 1px 2px 0 rgb(0 0 0 / 0.05)', label: 'Extra Pequena' },
                    { value: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)', label: 'Pequena' },
                    { value: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)', label: 'Média' },
                    { value: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)', label: 'Grande' },
                    { value: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)', label: 'Extra Grande' },
                    { value: '0 25px 50px -12px rgb(0 0 0 / 0.25)', label: 'Extra Extra Grande' },
                ]),
            ],
        },
        botao: {
            campos: [
                new TextInput(),
                new DropdownSelector('Preenchimento', 'silhueta', [
                    { value: '', label: 'Padrão' },
                    { value: 'outlined', label: 'Vazado' },
                ]),
                new DropdownSelector('Tamanho', 'tamanho', [
                    { value: 'pequeno', label: 'Pequeno' },
                    { value: 'medio', label: 'Médio' },
                    { value: 'grande', label: 'Grande' },
                ]),
                new DropdownSelector('Sombra', 'boxShadow', [
                    { value: 'unset', label: 'Sem Sombra' },
                    { value: '0 1px rgb(0 0 0 / 0.05)', label: 'Extra Extra Pequena' },
                    { value: '0 1px 2px 0 rgb(0 0 0 / 0.05)', label: 'Extra Pequena' },
                    { value: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)', label: 'Pequena' },
                    { value: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)', label: 'Média' },
                    { value: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)', label: 'Grande' },
                    { value: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)', label: 'Extra Grande' },
                    { value: '0 25px 50px -12px rgb(0 0 0 / 0.25)', label: 'Extra Extra Grande' },
                ]),
                new DropdownSelector('Borda', 'arredondamento', [
                    { value: 'raised', label: 'Padrão' },
                    { value: 'rounded', label: 'Arredondado' },
                ]),
                new BackgroundColor({ useStyle: false }),
                new ActionSelector(),
            ],
        },
        video: {
            campos: [new TextInput({ label: 'URL do vídeo', prop: 'url' }), new DimensionInput('Largura', 'largura'), new DimensionInput('Altura', 'altura')],
        },
        mapa: {
            campos: [new TextInput({ label: 'Url Google Maps', prop: 'url' }), new SliderInput({ label: 'Zoom do Mapa', prop: 'zoom', min: 1, max: 21 })],
        },
        banner: {
            campos: [
                new TextInput({ label: 'Título', prop: 'titulo' }),
                {
                    componente: SeletorMultiplasImagens,
                    componenteProps: {
                        label: 'Selecionar Imagem',
                    },
                    obterValorAtual: (elemento) => ({
                        imagens: elemento?.props?.imagens || [],
                        width: elemento?.props?.width || 100,
                        fundoTransparente: elemento?.props?.fundoTransparente || false,
                    }),
                    lidarComMudanca: (valor, componenteId) => {
                        const novasProps = {};
                        if (valor.imagens) novasProps.imagens = valor.imagens;
                        if (valor.width) novasProps.width = valor.width;
                        novasProps.fundoTransparente = valor.fundoTransparente;

                        store.dispatch(`${NOME_MODULO_VUEX}/atualizarPropsComponente`, {
                            idComponente: componenteId,
                            novasProps,
                        });
                    },
                },
                new NumberInput({ label: 'Intervalo (ms)', prop: 'intervalo', min: 1000, max: 10000 }),
                new CheckboxInput('Auto Play', 'autoPlay'),
                new CheckboxInput('Mostrar Controles', 'mostrarControles'),
                new CheckboxInput('Constroles Externos', 'setasExternas'),
                new CheckboxInput('Mostrar Indicadores', 'mostrarIndicadores'),
            ],
        },
        card: {
            campos: [
                new TextInput({ label: 'Título', prop: 'titulo' }),
                new TextInput({ label: 'Texto', prop: 'descricao' }),
                new ImageSrc({ label: 'Selecionar Imagem', prop: 'imagem' }),
                new DropdownSelector('Orientação', 'flexDirection', [
                    { label: 'Vertical', value: 'column' },
                    { label: 'Horizontal', value: 'row' },
                ]),
                new StyleSliderInput({ label: 'Borda', prop: 'borderRadius' }),
                new DropdownSelector('Sombra', 'boxShadow', [
                    { value: 'unset', label: 'Sem Sombra' },
                    { value: '0 1px rgb(0 0 0 / 0.05)', label: 'Extra Extra Pequena' },
                    { value: '0 1px 2px 0 rgb(0 0 0 / 0.05)', label: 'Extra Pequena' },
                    { value: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)', label: 'Pequena' },
                    { value: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)', label: 'Média' },
                    { value: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)', label: 'Grande' },
                    { value: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)', label: 'Extra Grande' },
                    { value: '0 25px 50px -12px rgb(0 0 0 / 0.25)', label: 'Extra Extra Grande' },
                ]),
                new DropdownSelector('Preenchimento de Imagem', 'objectFit', [
                    { value: 'none', label: 'Sem Preenchimento (padrão)' },
                    { value: 'fill', label: 'Preencher (reduz qualidade)' },
                    { value: 'cover', label: 'Preencher (corta a imagem)' },
                    { value: 'contain', label: 'Manter Proporção' },
                ]),
                new BackgroundColor({ useStyle: false }),
            ],
        },
        container: {
            campos: [
                new DropdownSelector(
                    'Justificação',
                    'justifyContent',
                    [
                        { value: 'center', label: 'Centro' },
                        { value: 'start', label: 'Começo' },
                        { value: 'end', label: 'Fim' },
                        { value: 'space-between', label: 'Espaço entre' },
                        { value: 'space-around', label: 'Espaço ao redor' },
                        { value: 'space-evenly', label: 'Separados Igualmente' },
                    ],
                    lidarMudancaEstilo,
                    obterValorEstilo
                ),
                new DropdownSelector(
                    'Alinhamento',
                    'alignItems',
                    [
                        { value: 'start', label: 'Começo' },
                        { value: 'end', label: 'Fim' },
                        { value: 'center', label: 'Centro' },
                        { value: 'stretch', label: 'Esticado' },
                    ],
                    lidarMudancaEstilo,
                    obterValorEstilo
                ),
                new StyleSliderInput({ label: 'Margem Superior', prop: 'padding-top', useStyle: true }),
                new StyleSliderInput({ label: 'Margem Inferior', prop: 'padding-bottom', useStyle: true }),
                new StyleSliderInput({ label: 'Margem Esquerda', prop: 'padding-left', useStyle: true }),
                new StyleSliderInput({ label: 'Margem Direita', prop: 'padding-right', useStyle: true }),
                new DropdownSelector(
                    'Orientação',
                    'flex-direction',
                    [
                        { label: 'Vertical', value: 'column' },
                        { label: 'Horizontal', value: 'row' },
                    ],
                    lidarMudancaEstilo,
                    obterValorEstilo
                ),
                new StyleSliderInput({ label: 'Espaçamento', prop: 'gap', useStyle: true }),
            ],
        },
        grade: {
            campos: [
                new NumberInput({ label: 'Numero de Linhas', prop: 'linhas', min: 1, max: 12, funcaoManipuladora: lidarMudancaGrade }),
                new NumberInput({ label: 'Numero de Colunas', prop: 'colunas', min: 1, max: 12, funcaoManipuladora: lidarMudancaGrade }),
                new DropdownSelector('Justificação', 'justifyItems', [
                    { value: 'center', label: 'Centro' },
                    { value: 'start', label: 'Começo' },
                    { value: 'end', label: 'Fim' },
                    { value: 'stretch', label: 'Esticado' },
                ]),
                new DropdownSelector('Alinhamento', 'alignItems', [
                    { value: 'center', label: 'Centro' },
                    { value: 'start', label: 'Começo' },
                    { value: 'end', label: 'Fim' },
                    { value: 'stretch', label: 'Esticado' },
                ]),
                new StyleSliderInput({ label: 'Espaçamento', prop: 'gap', useStyle: false }),
                new StyleSliderInput({ label: 'Margem Superior', prop: 'paddingTop', useStyle: false }),
                new StyleSliderInput({ label: 'Margem Inferior', prop: 'paddingBottom', useStyle: false }),
                new StyleSliderInput({ label: 'Margem Esquerda', prop: 'paddingLeft', useStyle: false }),
                new StyleSliderInput({ label: 'Margem Direita', prop: 'paddingRight', useStyle: false }),
            ],
        },
        nome: {
            campos: [new TextInput({ label: 'Titulo', prop: 'label' }), new TextInput({ label: 'Placeholder', prop: 'placeholder' })],
        },
        campoTexto: CONFIG_PADRAO_CAMPOS,
        campoNumerico: CONFIG_NUMERICO_CAMPOS,
        campoDropdown: {
            campos: [
                seletorTipoDeCampo,
                new TextInput({ label: 'Titulo do Campo', prop: 'label' }),
                new BooleanDropdownSelector('Obrigatório', 'required', [
                    { value: false, label: 'Não' },
                    { value: true, label: 'Sim' },
                ]),
                new EditorOpcoesDropdownModal('Editar opções do select', 'opcoesList'),
            ],
        },
        campoCNPJ: CONFIG_PADRAO_CAMPOS,
        campoCep: CONFIG_PADRAO_CAMPOS,
        campoEmail: CONFIG_PADRAO_CAMPOS,
        campoCheckbox: {
            campos: [
                seletorTipoDeCampo,
                new TextInput({ label: 'Titulo do Campo', prop: 'label' }),
                new BooleanDropdownSelector('Obrigatório', 'required', [
                    { value: false, label: 'Não' },
                    { value: true, label: 'Sim' },
                ]),
            ],
        },
        campoData: CONFIG_DATA_CAMPOS,
        botaoEnviar: {
            campos: [
                new TextInput(),
                new DropdownSelector('Posição', 'alinhamento', [
                    { value: 'start', label: 'Esquerda' },
                    { value: 'center', label: 'Centro' },
                    { value: 'end', label: 'Direita' },
                ]),
                new ColorPicker({ useStyle: false, label: 'Cor', prop: 'cor' }),
            ],
        },
        botaoLimparCampos: {
            campos: [
                new DropdownSelector(
                    'Posição',
                    'alinhamento',
                    [
                        { value: 'start', label: 'Esquerda' },
                        { value: 'center', label: 'Centro' },
                        { value: 'end', label: 'Direita' },
                    ],
                    lidarMudancaBotaoLimpar
                ),
                {
                    componente: SeletorCor,
                    componenteProps: {
                        label: 'Cor',
                    },
                    prop: 'cor',
                    lidarComMudanca: (valor, componenteId) => {
                        const corCompleta = valor.startsWith('#') ? valor : `#${valor}`;
                        lidarMudancaBotaoLimpar(corCompleta, componenteId, 'cor');
                    },
                    obterValorAtual: (elemento) => {
                        return elemento?.props?.cor?.replace('#', '') || '6c757d';
                    },
                },
            ],
        },
        telefone: CONFIG_SOMENTE_OBRIGATORIO,
        email: CONFIG_SOMENTE_OBRIGATORIO,
        cargo: CONFIG_SOMENTE_OBRIGATORIO,
        empresa: CONFIG_SOMENTE_OBRIGATORIO,
        setor: CONFIG_SOMENTE_OBRIGATORIO,
        texto: {
            campos: [
                new DropdownSelector(
                    'Tamanho da Fonte',
                    'fontSize',
                    [], // As opções serão preenchidas dinamicamente abaixo
                    lidarMudancaPropriedade
                ),
                new EditorDeTextoInput({ label: 'Conteúdo', prop: 'texto' }),
            ],
        },
    };

    const obterCampos = (componente) => {
        const config = COMPONENT_CONFIGS[componente];
        const campoTamanhoFonte = config?.campos?.find((c) => c.prop === 'fontSize');
        if (componente === 'texto' && campoTamanhoFonte) {
            campoTamanhoFonte.componenteProps.options = [
                '10px',
                '11px',
                '12px',
                '13px',
                '14px',
                '15px',
                '16px',
                '20px',
                '24px',
                '32px',
                '36px',
                '40px',
                '48px',
                '64px',
                '96px',
                '128px',
            ].map((t) => ({ value: t, label: t }));
        }
        return config?.campos ?? [];
    };

    return {
        obterCampos,
    };
};
